module.exports = __webpack_public_path__ + "static/img/source_3.b2fdced.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/module/dataIndex/static/source_3.png
// module id = PMj9
// module chunks = 60